/**
 * 字段权限数据管理服务
 * PBI-8697: 企业自定义字段高级权限设置
 */
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import { searchFieldPermissionsApi, setFieldPermissionsApi, } from '@cores/apis/workspace_api/field_permission';
import { i18nSymbol } from '@/i18n';
let FieldPermissionService = class FieldPermissionService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    /**
     * 查询字段权限配置（新版接口）
     */
    async searchFieldPermissions(request) {
        try {
            return await searchFieldPermissionsApi(request);
        }
        catch (error) {
            console.error('[FieldPermissionService] searchFieldPermissions failed:', error);
            throw error;
        }
    }
    /**
     * 设置字段权限（新版批量接口）
     */
    async setFieldPermissions(request) {
        try {
            await setFieldPermissionsApi(request);
        }
        catch (error) {
            console.error('[FieldPermissionService] setFieldPermissions failed:', error);
            throw error;
        }
    }
    /**
     * 获取权限级别描述
     */
    getPermissionLevelText(level) {
        const i18nKey = `customField.permissionLevels.${level}`;
        // 先尝试使用字段权限专用的国际化key
        if (this.i18n.te(i18nKey)) {
            return this.i18n.t(i18nKey);
        }
        // 降级使用通用权限级别的国际化key
        const fallbackMap = {
            HIDDEN: 'customField.permissionLevels.HIDDEN',
            READ: 'customField.permissionLevels.READ',
            TAG: 'customField.permissionLevels.TAG',
            MANAGE: 'customField.permissionLevels.MANAGE',
        };
        const fallbackKey = fallbackMap[level];
        if (fallbackKey && this.i18n.te(fallbackKey)) {
            return this.i18n.t(fallbackKey);
        }
        // 最后的兜底值
        return level;
    }
    /**
     * 获取所有权限级别选项
     */
    getPermissionLevelOptions() {
        return [
            {
                value: 'HIDDEN',
                label: this.getPermissionLevelText('HIDDEN'),
            },
            {
                value: 'READ',
                label: this.getPermissionLevelText('READ'),
            },
            {
                value: 'TAG',
                label: this.getPermissionLevelText('TAG'),
            },
            {
                value: 'MANAGE',
                label: this.getPermissionLevelText('MANAGE'),
            },
        ];
    }
    /**
     * 检查是否为企业管理员
     */
    isCompanyAdmin(user) {
        return user.role_in_company === 1;
    }
    /**
     * 获取用户显示名称
     */
    getUserDisplayName(user) {
        return user.user_name || user.user_email || user.user_phone || user.user_id;
    }
    /**
     * 获取用户联系信息（优先手机号，其次邮箱）
     */
    getUserContactInfo(user) {
        return user.user_phone || user.user_email || '';
    }
    /**
     * 获取用户头像字母
     */
    getUserAvatarLetter(user) {
        const name = this.getUserDisplayName(user);
        return name.charAt(0).toUpperCase();
    }
};
FieldPermissionService = __decorate([
    injectable(),
    __param(0, inject(i18nSymbol)),
    __metadata("design:paramtypes", [Object])
], FieldPermissionService);
export { FieldPermissionService };
